import tw, { styled } from 'twin.macro';

const WrapperEmpty = styled.div(
  tw`w-full flex justify-center items-center bg-gray-50 text-gray-500 h-28 rounded-lg`
);

export default WrapperEmpty;
